<template>


	<div class="wrapper" v-on-clickaway="clickAway">
		<button class="button button-icon white" @click="toggleActive">
			<icon-letter-spacing />
		</button>
		<div v-if="active" class="slider-container">
			<input v-model="handler" @input="input" type="range" min="-1" max="5" step="0.1">
		</div>
	</div>

</template>

<style scoped>

.wrapper{ position: relative; }
.button svg {
	width:18px !important;
	height:14px !important;
}

.slider-container {
	position:absolute;
	padding:16px 12px;
	background:#0F0F1A;
	width:264px;
	border-radius: 4px;
	z-index:2;
}
input {
	display:block;
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 4px;
  border-radius: 3px;
	background:#7855F2;
  outline: none; /* Remove outline */
  opacity: 1; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: .2s; /* 0.2 seconds transition on hover */
  transition: opacity .2s;
}


/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
input::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 16px;
  height: 16px;
	border:2px solid #7855F2;
  border-radius: 100%;
  background: #fff; /* Green background */
  cursor: pointer; /* Cursor on hover */
}
input::-moz-range-thumb {
  width: 16px;
  height: 16px;
	border:2px solid #7855F2;
  border-radius: 100%;
  background: #fff; /* Green background */
	cursor: pointer; /* Cursor on hover */
}
@media (min-width:992px){
	.slider-container { top:100%; top:calc(100% + 5px);}
}

</style>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import IconLetterSpacing from '../icons/LetterSpacing';
export default {
	props:['value'],
	mixins: [ clickaway ],
	components:{
		IconLetterSpacing
	},
	data(){
		return {
			handler:'',
			active:false,
		}
	},
	methods:{
		clickAway(){
			if(!this.active) return;
			this.active = false;
			this.$emit('closeInput');
		},
		toggleActive(){
			this.active = !this.active;
			if(this.active) this.$emit('openInput');
			if(!this.active) this.$emit('closeInput');
		},
		input(){
			this.$emit('input',this.handler)
		}
	},
	mounted(){
		this.handler = this.value || 0;
		document.body.addEventListener('keydown',(e)=>{ if(e.keyCode==27) this.clickAway(); })
	},


}
</script>